// Browser entry point of the XLSX export: loads ExcelJS lazily, encodes the
// images, builds the workbook and downloads it.

import { buildQuoteWorkbook } from "./buildQuoteWorkbook";
import { loadProductImages, toExcelImage } from "./quoteImages";

export const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

function downloadBuffer(buffer, fileName) {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(new Blob([buffer], { type: XLSX_MIME }));
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}

/**
 * Same options as buildQuoteWorkbook, except images are given as sources:
 * @param {HTMLCanvasElement} opts.coverCanvas  screenshot of the cover page
 * @param {string} opts.footerUrl
 * @param {string} opts.logoUrl
 * @param {Function} opts.productImage  product => url
 * @param {string} opts.fallbackImageUrl
 * @param {string} opts.fileName
 */
export async function exportQuoteXlsx(opts) {
  const ExcelJSModule = await import(
    /* webpackChunkName: "exceljs" */ "exceljs"
  );
  const ExcelJS = ExcelJSModule.default || ExcelJSModule;

  const [cover, footer, logo, products] = await Promise.all([
    toExcelImage(opts.coverCanvas, { maxWidth: 2000 }),
    toExcelImage(opts.footerUrl, { maxWidth: 2000 }),
    toExcelImage(opts.logoUrl, { maxWidth: 400, type: "png" }).catch(
      () => null
    ),
    loadProductImages(
      opts.groups.flat().filter(Boolean),
      opts.productImage,
      opts.fallbackImageUrl
    ),
  ]);

  const { workbook } = buildQuoteWorkbook(ExcelJS, {
    ...opts,
    images: { cover, footer, logo, products },
  });
  downloadBuffer(await workbook.xlsx.writeBuffer(), opts.fileName);
}
